import React, { useEffect, createElement } from 'react';
import { Landing } from './pages/Landing';
const META_PIXEL_ID = '25855226074068949';
const PAGE_TITLE = 'MEGAPACK Lectura Fluida — Ayudá a tu hijo a leer con fluidez en 30 días';
const PAGE_DESC = 'Sistema para padres de niños de 6 a 10 años: métodos visuales y sesiones de 10 minutos por día para mejorar la lectura sin peleas ni frustración. 100% PDF, acceso inmediato.';
function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
export function App() {
  // SEO: title, meta description, lang, social/OG tags, structured data
  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.documentElement.lang = 'es-AR';
    document.title = PAGE_TITLE;
    setMeta('name', 'description', PAGE_DESC);
    setMeta('name', 'viewport', 'width=device-width, initial-scale=1, viewport-fit=cover');
    setMeta('name', 'theme-color', '#1e293b');
    setMeta('name', 'robots', 'index, follow');
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:title', PAGE_TITLE);
    setMeta('property', 'og:description', PAGE_DESC);
    setMeta('property', 'og:locale', 'es_AR');
    setMeta('property', 'og:image', 'https://cdn.magicpatterns.com/uploads/15nmDg4KgxufQZmTYd47N1/Texto_del_parrafo_(6).webp');
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', PAGE_TITLE);
    setMeta('name', 'twitter:description', PAGE_DESC);
    // Structured data (Product) for richer SEO
    const ldId = 'ld-product-schema';
    if (!document.getElementById(ldId)) {
      const ld = document.createElement('script');
      ld.id = ldId;
      ld.type = 'application/ld+json';
      ld.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: 'MEGAPACK Lectura Fluida',
        description: PAGE_DESC,
        image: 'https://cdn.magicpatterns.com/uploads/15nmDg4KgxufQZmTYd47N1/Texto_del_parrafo_(6).webp',
        brand: {
          '@type': 'Brand',
          name: 'Tu Punto Digital'
        },
        offers: {
          '@type': 'Offer',
          price: '19990',
          priceCurrency: 'ARS',
          availability: 'https://schema.org/InStock',
          url: 'https://www.tupuntodigital.shop/cart/46104364679341:1'
        }
      });
      document.head.appendChild(ld);
    }
  }, []);
  // Meta Pixel — loads on the published domain (Pixel Helper only detects it there, not in the editor preview)
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    const w = window as any;
    if (w.fbq) {
      w.fbq('track', 'PageView');
      return;
    }
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    w.fbq = n;
    if (!w._fbq) w._fbq = n;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const target = document.head || document.body || document.documentElement;
    target.appendChild(script);
    w.fbq('init', META_PIXEL_ID);
    w.fbq('track', 'PageView');
    // <noscript> fallback so the pixel still counts the view without JS
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.alt = '';
    img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    target.appendChild(noscript);
  }, []);
  return <Landing data-id="element-0" />;
}